var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Component, Watch } from 'vue-property-decorator';
import AddDialog from './AddDialog.vue';
import SupplierService from '../../../api/SupplierService';
var SupplierTable = (function (_super) {
    __extends(SupplierTable, _super);
    function SupplierTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.height = document.documentElement.clientHeight - 220;
        _this.Columns = [];
        return _this;
    }
    SupplierTable.prototype.dataWatch = function (val, oldVal) {
        if (val && val.length) {
            this.$refs.table.bodyWrapper.scrollTop = 0;
        }
    };
    SupplierTable.prototype.created = function () {
        this.service = SupplierService.getInstance();
    };
    SupplierTable.prototype.selectionChange = function (rows) {
        this.$emit('setSelectRows', rows);
    };
    SupplierTable.prototype.sortChange = function (pager) {
        this.$emit('sortChange', pager);
    };
    SupplierTable.prototype.edit = function (supplier_upper_id) {
        var _this = this;
        this.service.deatilUpper({ supplier_upper_id: supplier_upper_id }).then(function (res) {
            var instance = _this.$dialog(AddDialog, {
                detailData: res.data.data
            }, {
                title: "编辑供应商",
                width: 640,
                height: 600
            }).instance;
            instance.$on("save:ok", function () {
                _this.$emit('search');
            });
        }).catch(function (err) {
        });
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], SupplierTable.prototype, "listData", void 0);
    __decorate([
        Watch("data")
    ], SupplierTable.prototype, "dataWatch", null);
    SupplierTable = __decorate([
        Component
    ], SupplierTable);
    return SupplierTable;
}(Vue));
export default SupplierTable;
